// extracted by mini-css-extract-plugin
export default {"parent":"cancelLeaseNoteModal_parent__ygvzp","parentSiteManager":"cancelLeaseNoteModal_parentSiteManager__U777B"};